/* eslint-disable react/prop-types */
import React, { useState, Suspense } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import PageErrorBoundary from "./components/common/PageErrorBoundary";
import "./axiosAuthSetup";

import Login from "./components/Login";
import DashboardLayout from "./components/DashboardLayout";


import RekapSanksi from "./components/HRD/RekapSanksi";
import EngineeringWO from "./components/ENGINEERING/EngineeringWO";
import RekapNegatifPoin from "./components/HRD/RekapNegatifPoin";
const Henkaten = React.lazy(() => import("./components/PRODUKSI/Henkaten"));
const ReadmineJigMasterPart = React.lazy(() => import("./components/QUALITY/ReadmineJigMasterPart"));

// === PAGE LAZY IMPORTS: Stage 6 ===
const JadwalBooking = React.lazy(() => import("./components/JadwalBooking"));
const BookingForm = React.lazy(() => import("./components/BookingForm"));
const AddUserForm = React.lazy(() => import("./components/AddUserForm"));
const DaftarBooking = React.lazy(() => import("./components/DaftarBooking"));
const DokumenInternal = React.lazy(() => import("./components/DokumenInternal"));
const DokumenEksternal = React.lazy(() => import("./components/DokumenEksternal"));
const SopPerusahaan = React.lazy(() => import("./components/SopPerusahaan"));
const CompanyDocuments = React.lazy(() => import("./components/CompanyDocuments"));
const PeraturanPerusahaan = React.lazy(() => import("./components/PeraturanPerusahaan"));
const Iso9001 = React.lazy(() => import("./components/Iso9001"));
const Dashboard = React.lazy(() => import("./components/Dashboard"));
const ReportDashboard = React.lazy(() => import("./components/ReportDashboard"));
const RisalahMeeting = React.lazy(() => import("./components/RisalahMeeting"));
const MonitoringDisplay = React.lazy(() => import("./components/MonitoringDisplay"));
const MonitoringDisplayArmadaFull = React.lazy(() => import("./components/MonitoringDisplayArmadaFull"));
const InputPrep = React.lazy(() => import("./components/InputPrep"));
const MonitorPrep = React.lazy(() => import("./components/MonitorPrep"));
const RekapStokApp = React.lazy(() => import("./components/RekapStokApp"));
const FormInputStok = React.lazy(() => import("./components/FormInputStok"));
const Material = React.lazy(() => import("./components/material"));
const MaterialKomponen = React.lazy(() => import("./components/materialkomponen"));
const MaterialPlate = React.lazy(() => import("./components/materialplat"));
const MaterialPipa = React.lazy(() => import("./components/materialpipa"));
const DashboardMaterial = React.lazy(() => import("./components/DashboardMaterial"));
const DelipInput = React.lazy(() => import("./components/DelipInput"));
const MonitoringDelip = React.lazy(() => import("./components/MonitoringDelip"));
const MonitoringWaterFlow = React.lazy(() => import("./components/MonitoringWaterFlow"));
const Kakotora = React.lazy(() => import("./components/kakotora"));
const KedatanganMaterial = React.lazy(() => import("./components/MT/KedatanganMaterial"));
const MTKedatanganDashboard = React.lazy(() => import("./components/MT/MTKedatanganDashboard"));
const JobProfile = React.lazy(() => import("./components/HRD/JobProfile"));
const OEEDJT = React.lazy(() => import("./components/OEE"));
const RekapTraining = React.lazy(() => import("./components/HRD/RekapTraining"));
const TicketingProblem = React.lazy(() => import("./components/TICKET/TicketingProblem"));
const ScheduleMaintenance = React.lazy(() => import("./components/TICKET/ScheduleMaintenance"));
const CctvMonitor = React.lazy(() => import("./components/TICKET/CctvMonitor"));
const JobProfilePublic = React.lazy(() => import("./components/HRD/JobProfilePublic"));
const MaterialDisplaySlider = React.lazy(() => import("./components/MT/MaterialDisplaySlider"));
const MatrixTrainingKaryawan = React.lazy(() => import("./components/Matrix/MatrixTrainingKaryawan"));
const SuratJalanRpb = React.lazy(() => import("./components/PPIC/SuratJalanRpb"));
// === END PAGE LAZY IMPORTS ===

function normalizePerms(raw) {
  try {
    if (Array.isArray(raw)) return raw;
    if (typeof raw === "string" && raw.trim()) return JSON.parse(raw);
    if (raw && typeof raw === "object") return raw;
  } catch {}
  return [];
}

function normalizeDepts(raw) {
  try {
    if (Array.isArray(raw)) return raw.filter(Boolean);
    if (typeof raw === "string" && raw.trim()) return JSON.parse(raw);
    if (raw && typeof raw === "object") return raw;
  } catch {}
  return [];
}

const PERMISSION_ROUTES = [
  { perm: "dashboard.view", path: "/" },

  { perm: "room.add", path: "/form" },
  { perm: "room.list", path: "/daftar" },

  { perm: "monitoring.display", path: "/monitoring-display" },
  { perm: "monitoring.delivery", path: "/dashboard" },
  { perm: "report.delivery", path: "/report" },
  { perm: "ppic.sj_rpb.view", path: "/ppic/sj-rpb" },

  { perm: "prep.monitor", path: "/prep/monitor" },
  { perm: "prep.input", path: "/prep/input" },
  { perm: "delip.monitor", path: "/delip/monitor" },
  { perm: "delip.input", path: "/delip/input" },

  { perm: "materials.view", path: "/material/dashboard" },
  { perm: "materials.input", path: "/materials" },
  { perm: "komponen.input", path: "/komponen" },
  { perm: "plate.input", path: "/plate" },
  { perm: "pipa.input", path: "/pipa" },

  { perm: "engineering.wo.view", path: "/engineering/wo" },
  { perm: "monitoring.waterflow", path: "/monitoring-water-flow" },
  { perm: "mt.kedatangan.view", path: "/mt/kedatangan-material" },
  { perm: "mt.kedatangan.dashboard", path: "/mt/kedatangan-material/dashboard" },
  { perm: "kakotora.view", path: "/kakotora" },
  { perm: "oee.view", path: "/produksi/oee" },
  { perm: "produksi.henkaten.view", path: "/produksi/henkaten" },

  { perm: "docs.internal.sop", path: "/dokumen-internal/sop" },
  { perm: "docs.internal.peraturan", path: "/peraturan-perusahaan" },
  { perm: "docs.external.iso", path: "/iso-9001" },

  { perm: "hrd.skill_matrix.job_profile.view", path: "/hrd/skill-matrix/job-profile" },
  { perm: "user.manage", path: "/add-user" },
  { perm: "hrd.skill_matrix.rekap_training.view", path: "/hrd/skill-matrix/rekap-training" },
  { perm: "hrd.skill_matrix.rekap_training.view", path: "/hrd/skill-matrix/rekap-sanksi" },
  { perm: "hrd.matrix_training.view", path: "/hrd/matrix-training" },
  { perm: "it.ticketing.view", path: "/it/ticketing-problem" },
  { perm: "it.schedule_maintenance.view", path: "/it/schedule-maintenance" },
  { perm: "it.cctv_monitor.view", path: "/it/cctv-monitor" },
  { perm: "stok.input", path: "/stok/input" },
  { perm: "stok.view", path: "/stok/rekap" },
  { perm: "docs.internal.view", path: "/dokumen-internal" },
  { perm: "docs.external.view", path: "/dokumen-eksternal" },
];

/* STAGE 6 PAGE MAPPING ACTIVE: lazy loading + page error boundary */
function App() {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem("user");
    if (!savedUser) return null;
    try {
      const u = JSON.parse(savedUser);
      return {
        ...u,
        permissions: normalizePerms(u.permissions),
        dept_roles: normalizeDepts(u.dept_roles),
      };
    } catch {
      return null;
    }
  });

  const isSuperAdminUser = (u) => String(u?.username || "").toLowerCase() === "admin";

  const hasPerm = (key) => {
    if (!user) return false;
    if (isSuperAdminUser(user)) return true;
    return normalizePerms(user.permissions).includes(key);
  };

  const getFirstAllowedRoute = () => {
    if (!user) return "/login";
    if (isSuperAdminUser(user)) return "/";

    const perms = normalizePerms(user.permissions) || [];
    const found = PERMISSION_ROUTES.find((r) => perms.includes(r.perm));
    return found ? found.path : "/";
  };

  const withPageBoundary = (child) => (
    <PageErrorBoundary>
      <Suspense fallback={<div className="p-3 text-muted">Memuat halaman...</div>}>
        {child}
      </Suspense>
    </PageErrorBoundary>
  );

  const wrapLayout = (child) => (
    <DashboardLayout
      role={user.role}
      userId={user.id}
      username={user.username}
      permissions={normalizePerms(user.permissions)}
      deptRoles={normalizeDepts(user.dept_roles)}
    >
      {withPageBoundary(child)}
    </DashboardLayout>
  );

  const requirePerm = (permKey, child) =>
    wrapLayout(
      hasPerm(permKey) ? child : <div className="alert alert-danger mt-3">Akses ditolak.</div>
    );

  const hasAnyPermRoute = (permKeys = []) => {
    if (!user) return false;
    if (isSuperAdminUser(user)) return true;
    return permKeys.some((k) => hasPerm(k));
  };

  const requireAnyPerm = (permKeys, child) =>
    wrapLayout(
      hasAnyPermRoute(permKeys)
        ? child
        : <div className="alert alert-danger mt-3">Akses ditolak.</div>
    );

  if (!user) {
    return (
      <Router>
        <Routes>
          <Route path="/monitoring-display" element={withPageBoundary(<MonitoringDisplay />)} />
          <Route path="/display/armada" element={withPageBoundary(<MonitoringDisplayArmadaFull />)} />
          <Route path="/job-profile/public/:token" element={withPageBoundary(<JobProfilePublic />)} />
          <Route path="/display/material" element={withPageBoundary(<MaterialDisplaySlider />)} />
          <Route
            path="*"
            element={
              <Login
                onLogin={(u) => {
                  const fixed = {
                    ...u,
                    permissions: normalizePerms(u.permissions),
                    dept_roles: normalizeDepts(u.dept_roles),
                  };
                  localStorage.setItem("user", JSON.stringify(fixed));
                  setUser(fixed);
                }}
              />
            }
          />
        </Routes>
      </Router>
    );
  }

 return (
  <Router>
    <Routes>
      <Route path="/monitoring-display" element={withPageBoundary(<MonitoringDisplay />)} />
      <Route path="/display/armada" element={withPageBoundary(<MonitoringDisplayArmadaFull />)} />
      <Route path="/display/material" element={withPageBoundary(<MaterialDisplaySlider />)} />

      {/* PUBLIC QR - TANPA LOGIN */}
      <Route path="/job-profile/public/:token" element={withPageBoundary(<JobProfilePublic />)} />
  

        <Route
          path="/"
          element={
            hasPerm("dashboard.view")
              ? wrapLayout(<JadwalBooking role={user.role} userId={user.id} />)
              : <Navigate to={getFirstAllowedRoute()} replace />
          }
        />

        <Route path="/monitoring-water-flow" element={requirePerm("monitoring.waterflow", <MonitoringWaterFlow />)} />
        <Route path="/hrd/skill-matrix/job-profile" element={requirePerm("hrd.skill_matrix.job_profile.view", <JobProfile />)} />
        <Route path="/produksi/oee" element={requirePerm("oee.view", <OEEDJT />)} />
        <Route path="/produksi/henkaten" element={requirePerm("produksi.henkaten.view", <Henkaten username={user.username} />)} />
        <Route
          path="/it/ticketing-problem"
          element={requirePerm("it.ticketing.view", <TicketingProblem />)}
        />
        <Route
          path="/it/schedule-maintenance"
          element={requirePerm("it.schedule_maintenance.view", <ScheduleMaintenance />)}
        />
        <Route
          path="/it/cctv-monitor"
          element={requirePerm("it.cctv_monitor.view", <CctvMonitor />)}
        />
        <Route path="/dashboard" element={requirePerm("monitoring.delivery", <Dashboard role={user.role} userId={user.id} />)} />
        <Route path="/report" element={requirePerm("report.delivery", <ReportDashboard />)} />

        <Route
          path="/ppic/sj-rpb"
          element={requirePerm(
            "ppic.sj_rpb.view",
            <SuratJalanRpb
              role={user.role}
              username={user.username}
            />
          )}
        />
        <Route path="/kakotora" element={requirePerm("kakotora.view", <Kakotora />)} />
        <Route path="/form" element={requirePerm("room.add", <BookingForm userId={user.id} />)} />
        <Route path="/daftar" element={requirePerm("room.list", <DaftarBooking role={user.role} userId={user.id} />)} />

        {/* SIP_COMPANY_DOC_ROUTES_R1 */}
        <Route
          path="/dokumen-perusahaan"
          element={requireAnyPerm(
            [
              "docs.company.view", "docs.company.create", "docs.company.update",
              "docs.company.delete", "docs.company.admin",
              "docs.internal.sop", "docs.internal.peraturan", "docs.external.iso",
              "docs.internal.view", "docs.external.view"
            ],
            <CompanyDocuments role={user.role} userId={user.id} username={user.username} permissions={normalizePerms(user.permissions)} />
          )}
        />
        <Route
          path="/dokumen-perusahaan/:categoryCode"
          element={requireAnyPerm(
            [
              "docs.company.view", "docs.company.create", "docs.company.update",
              "docs.company.delete", "docs.company.admin",
              "docs.internal.sop", "docs.internal.peraturan", "docs.external.iso",
              "docs.internal.view", "docs.external.view"
            ],
            <CompanyDocuments role={user.role} userId={user.id} username={user.username} permissions={normalizePerms(user.permissions)} />
          )}
        />
        {/* END SIP_COMPANY_DOC_ROUTES_R1 */}

        <Route
          path="/dokumen-internal/sop"
          element={requirePerm("docs.internal.sop", <SopPerusahaan role={user.role} userId={user.id} />)}
        />
        <Route
          path="/peraturan-perusahaan"
          element={requirePerm("docs.internal.peraturan", <PeraturanPerusahaan role={user.role} userId={user.id} />)}
        />
        <Route
          path="/iso-9001"
          element={requirePerm("docs.external.iso", <Iso9001 role={user.role} userId={user.id} />)}
        />

        <Route
          path="/dokumen-internal"
          element={requireAnyPerm(
            ["docs.internal.view", "docs.internal.sop", "docs.internal.peraturan", "dashboard.view"],
            <DokumenInternal role={user.role} userId={user.id} />
          )}
        />
        <Route
          path="/dokumen-eksternal"
          element={requireAnyPerm(
            ["docs.external.view", "docs.external.iso", "dashboard.view"],
            <DokumenEksternal role={user.role} userId={user.id} />
          )}
        />
        <Route
          path="/risalah/:bookingId"
          element={requireAnyPerm(
            ["room.list", "room.add", "dashboard.view"],
            <RisalahMeeting />
          )}
        />

        <Route
          path="/add-user"
          element={
            isSuperAdminUser(user) || hasPerm("user.manage")
              ? wrapLayout(<AddUserForm />)
              : wrapLayout(<div className="alert alert-danger mt-3">Akses ditolak.</div>)
          }
        />

        <Route path="/prep/monitor" element={requirePerm("prep.monitor", <MonitorPrep />)} />
        <Route path="/prep/input" element={requirePerm("prep.input", <InputPrep />)} />
        <Route path="/delip/monitor" element={requirePerm("delip.monitor", <MonitoringDelip />)} />
        <Route path="/delip/input" element={requirePerm("delip.input", <DelipInput />)} />
        <Route path="/mt/kedatangan-material" element={requirePerm("mt.kedatangan.view", <KedatanganMaterial />)} />
        <Route
          path="/mt/kedatangan-material/dashboard"
          element={requirePerm("mt.kedatangan.dashboard", <MTKedatanganDashboard />)}
        />
        
        <Route
          path="/hrd/skill-matrix/rekap-training"
          element={requirePerm("hrd.skill_matrix.rekap_training.view", <RekapTraining />)}
        />
          <Route
            path="/hrd/skill-matrix/rekap-sanksi"
            element={requirePerm("hrd.skill_matrix.rekap_training.view", <RekapSanksi />)}
          />

        <Route path="/hrd/rekap-negatif-poin" element={requirePerm("hrd.skill_matrix.rekap_training.view", <RekapNegatifPoin />)} />
<Route
          path="/hrd/matrix-training"
          element={requirePerm(
            "hrd.matrix_training.view",
            <MatrixTrainingKaryawan
              role={user.role}
              userId={user.id}
              permissions={normalizePerms(user.permissions)}
            />
          )}
        />

        <Route path="/stok/input" element={requirePerm("stok.input", <FormInputStok />)} />
        <Route path="/stok/rekap" element={requirePerm("stok.view", <RekapStokApp />)} />
        <Route path="/materials" element={requirePerm("materials.input", <Material />)} />
        <Route path="/komponen" element={requirePerm("komponen.input", <MaterialKomponen />)} />
        <Route path="/plate" element={requirePerm("plate.input", <MaterialPlate />)} />
        <Route path="/pipa" element={requirePerm("pipa.input", <MaterialPipa />)} />
        <Route path="/material/dashboard" element={requirePerm("materials.view", <DashboardMaterial />)} />

        <Route path="/material/komponen" element={<Navigate to="/komponen" replace />} />
        <Route path="/material/plate" element={<Navigate to="/plate" replace />} />
        <Route path="/material/pipa" element={<Navigate to="/pipa" replace />} />

        <Route path="*" element={<Navigate to={getFirstAllowedRoute()} replace />} />
              <Route path="/engineering/wo" element={requirePerm("engineering.wo.view", <EngineeringWO />)} />

        <Route path="/quality/readmine-jig-master-part" element={requirePerm("quality.readmine.view", <ReadmineJigMasterPart />)} />
      </Routes>
    </Router>
  );
}

export default App;
